import { Component } from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { first } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { PATIENT } from '../patient.constants';
import { PatientService } from '../patient.service';
import { PatientDialogComponent } from './patient-dialog.component';

@Component({
  selector: 'ms-common-patient',
  templateUrl: './patient-main.component.html',
})
export class PatientMainComponent extends BaseComponent {
  readonly screen = PATIENT;
  protected setScreen = true;
  patients: VonPageResponseModel<CommonPatientViewModel> =
    {} as VonPageResponseModel<CommonPatientViewModel>;
  selectedPatient: CommonPatientViewModel = {};
  options: MenuItem[] = [];
  dtDocumentFilter?: string;
  dtNameFilter?: string;

  constructor(
    protected service: PatientService,
    protected dialogService: DialogService
  ) {
    super();
  }

  onInit = () => {
    this.loading = true;
    this.subscriptions.push(
      this.service
        .readPatientLazyLoad()
        .subscribe(
          (patients: VonPageResponseModel<CommonPatientViewModel>) =>
            (this.patients = patients)
        )
    );
    this.setDefaultContextMenu();
  };

  openModal = (isNew: boolean = true) => {
    const dialogRef = this.service.openPatientDialog(
      isNew,
      PatientDialogComponent
    );
    const dialogComponent =
      this.dialogService.dialogComponentRefMap.get(dialogRef)?.instance;
    dialogComponent?.unbindGlobalListeners();
    dialogRef.onClose.subscribe(this.service.patientOnClose);
    dialogRef.onDestroy.pipe(first()).subscribe(() => {
      dialogComponent?.moveOnTop();
      dialogComponent?.bindGlobalListeners();
      dialogComponent?.focus();
    });
  };

  lazyReadPatients = ($event: LazyLoadEvent) => {
    this.service.setLoadingState();
    const page = $event.first! / $event.rows!;
    this.subscriptions.push(
      this.service
        .getPatients(
          page,
          $event.rows!,
          $event.filters!.fullName,
          $event.filters!.document
        )
        .subscribe()
    );
  };

  private setDefaultContextMenu = () => {
    this.options.push({
      id: 'edit',
      label: this.screen.actions.edit,
      styleClass: 'text-warning',
      icon: 'fas fa-pencil-alt',
      command: (_) =>
        this.subscriptions.push(
          this.service
            .getPatientById(this.selectedPatient.id!)
            .subscribe((patient) => {
              this.subscriptions.push(
                this.service.getPersonById(patient.person!).subscribe()
              );
              this.openModal(false);
            })
        ),
    });
  };
}
